import { Medium } from '@/types/types';

export const media: Medium[] = [
	{
		id: '88d4eb27-4f39-4e9b-96a3-7d2f67a8e6bc',
		name: 'Printanzeige',
	},
	{
		id: '67f48d19-73c8-4ec3-8c57-38b1a3e77a68',
		name: 'Plakat/Citylight',
	},
	{
		id: '59aaf7e4-92fc-473d-8c4b-78d2550bca6e',
		name: 'TV',
	},
	{
		id: '42bc9a21-6c9c-4b22-8128-1e14b7e2db50',
		name: 'Radio',
	},
	{
		id: 'bfb15b33-cf7c-4a3d-b6e7-f3e8dff98e5b',
		name: 'Flyer/Prospekt/Broschüre/Versandkatalog',
	},
	{
		id: '1e3a1dcf-646a-47a3-8d2a-8f6f84d7f957',
		name: 'Adressierte Werbesendung',
	},
	{
		id: '9cbeb888-ff1b-42ea-bb18-55f8f9d89c0b',
		name: 'Telefon/SMS',
	},
	{
		id: '3257df97-2b67-4b6a-a1eb-bb8764e0e8e6',
		name: 'Verkehrsmittel-Werbung',
	},
	{
		id: 'bc3f7c14-6a94-4d6d-b31e-66f08bfa29e7',
		name: 'Branding/Logo/Verpackung',
	},
	{
		id: 'e3f8977f-9b3b-4a88-83bc-eda3279f4784',
		name: 'KFZ-/LKW-Werbung',
	},
	{
		id: 'fa2a32b5-1f5f-4b8d-87e1-e307afda9e50',
		name: 'Online-/Display-Werbung',
	},
	{
		id: '0a4c6b92-29f4-4acb-89bc-4ff60d32fa53',
		name: 'E-Mail-Werbung',
	},
	{
		id: 'cfa6b86e-9b58-4514-89de-7d1bda5fb0c4',
		name: 'Soziale Medien',
	},
	{
		id: '3e5a5d82-435a-429d-8c6c-50cdd979d632',
		name: 'Influencer/Content Creators-Werbung',
	},
	{
		id: 'a4efb2b9-7580-472d-9831-3b48514ea8be',
		name: 'Website',
	},
];
